import { Target, Megaphone, ClipboardCheck, Send } from "lucide-react";

const STEPS = [
    { num: "01", key: "TARGET", icon: Target, title: "Target", body: "Identify your ideal buyer based on location, property type, budget and intent." },
    { num: "02", key: "ATTRACT", icon: Megaphone, title: "Attract", body: "AI-powered campaigns generate relevant enquiries through digital advertising and landing pages." },
    { num: "03", key: "QUALIFY", icon: ClipboardCheck, title: "Qualify", body: "Automatically assess enquiries using key buyer-intent signals." },
    { num: "04", key: "DELIVER", icon: Send, title: "Deliver", body: "Send enquiries to your sales team through WhatsApp, CRM or your preferred workflow." },
];

export default function HowItWorks() {
    return (
        <section
            id="how"
            data-testid="how-section"
            className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 border-t border-white/5 relative overflow-hidden"
        >
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="max-w-3xl mb-16">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="h-px w-10 bg-[#D4AF37]" />
                        <span className="overline">How It Works</span>
                    </div>
                    <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight leading-[1.05]">
                        From targeting to delivery. Four <span className="italic text-[#D4AF37]">simple steps</span>.
                    </h2>
                    <p className="mt-6 text-white/70 leading-relaxed max-w-xl">
                        We help real-estate businesses generate, qualify and deliver high-intent buyer enquiries
                        using AI-powered digital marketing.
                    </p>
                </div>

                {/* Steps grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="journey-grid">
                    {STEPS.map((s, i) => (
                        <div
                            key={s.title}
                            data-testid={`journey-${i + 1}`}
                            className="relative hol-card p-6 group"
                        >
                            {/* Step number */}
                            <div className="absolute top-4 right-4 font-serif-display text-4xl text-[#D4AF37]/25 group-hover:text-[#D4AF37]/60 transition-colors">
                                {s.num}
                            </div>

                            <div className="h-11 w-11 grid place-items-center border border-[#D4AF37]/40 text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-black transition-all">
                                <s.icon size={18} strokeWidth={1.5} />
                            </div>

                            <div className="mt-6 text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]/70">{s.key}</div>
                            <h3 className="mt-1 font-serif-display text-xl leading-tight">{s.title}</h3>
                            <p className="mt-3 text-xs text-white/60 leading-relaxed">{s.body}</p>

                            {i < STEPS.length - 1 && (
                                <div className="hidden lg:block absolute top-12 -right-2 h-px w-4 bg-gradient-to-r from-[#D4AF37]/40 to-transparent" />
                            )}
                        </div>
                    ))}
                </div>

                {/* Manifesto */}
                <div className="mt-24 max-w-4xl mx-auto text-center">
                    <div className="text-[#D4AF37]/70 font-serif-display text-6xl leading-none">"</div>
                    <p className="font-serif-display text-4xl sm:text-5xl leading-[1.1] tracking-tight -mt-4">
                        We don't sell leads. <br />
                        <span className="italic text-[#D4AF37]">We build demand.</span>
                    </p>
                    <p className="mt-6 text-sm text-white/40 uppercase tracking-[0.3em]">— The Lead Krafts Promise</p>
                </div>
            </div>
        </section>
    );
}
